import { Loading as UiLoading } from "@insights/ui";

export function Loading() {
  return <UiLoading>Loading Insights…</UiLoading>;
}
